import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-ivory text-center px-6">
      <p className="eyebrow mb-3">404</p>
      <h1 className="font-serif text-5xl sm:text-6xl text-pitch tracking-tight">Page not found</h1>
      <p className="text-stonemuted mt-4">The page you're looking for doesn't exist or has been moved.</p>
      <Link to="/" className="inline-block mt-8 bg-pitch text-ivory text-xs font-mono uppercase tracking-[0.2em] px-8 py-4">Return Home</Link>
    </div>
  );
}
